import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const Email = (props) => {
  return (
    <FormGroup controlId="email">
      <Col componentClass={ControlLabel} sm={5}>
        Email
      </Col>
    <Col sm={7}>
      <FormControl type="email" value={props.email}
        autoComplete="off"
        onChange={props.handleChangeEmail} />
    </Col>
    </FormGroup>
  )
}

Email.propTypes = {
  email: PropTypes.string,
  handleChangeEmail: PropTypes.func
};

export default Email;



// WEBPACK FOOTER //
// ./src/app/components/email/Email.js